'use client';

import { atom, useAtom } from 'jotai';
import dynamic from 'next/dynamic';
import { useCallback } from 'react';
import type { VipOnlyModalContainerProps } from '@app/_containers/vip-only-modal-container';

const VipOnlyModalContainer = dynamic<VipOnlyModalContainerProps>(() =>
  import('@app/_containers/vip-only-modal-container').then(
    (mod) => mod.VipOnlyModalContainer
  )
);

const isOpenVipOnlyModalAtom = atom<boolean>(false);
const vipOnlyStoryIdAtom = atom<string | undefined>(undefined);

export const useRequireVipOnlyStoryModal = () => {
  const [isOpen, setIsOpen] = useAtom(isOpenVipOnlyModalAtom);
  const [vipOnlyStoryId, setVipOnlyStoryId] = useAtom(vipOnlyStoryIdAtom);

  const open = useCallback(
    (storyId: string) => {
      setIsOpen(true);
      setVipOnlyStoryId(storyId);
    },
    [setIsOpen, setVipOnlyStoryId]
  );

  const close = useCallback(() => {
    setIsOpen(false);
    setVipOnlyStoryId(undefined);
  }, [setIsOpen, setVipOnlyStoryId]);

  return {
    open,
    close,
    isOpen,
    vipOnlyStoryId,
  };
};

type Props = {};

export const RequireVipOnlyStoryModalContainer = ({}: Props) => {
  const { isOpen, close, vipOnlyStoryId } = useRequireVipOnlyStoryModal();

  return (
    <>
      {isOpen && vipOnlyStoryId && (
        <VipOnlyModalContainer
          isOpen={isOpen}
          storyId={vipOnlyStoryId}
          onClose={close}
        />
      )}
    </>
  );
};
